import Section10 from './Section10'
export default Section10;